export default __webpack_public_path__ + "static/media/comment-board.95a1f181.svg";